import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
type CtaButtonProps = {
  label: string;
  id?: string;
  microcopy?: string;
  tone?: "light" | "dark";
};
export function CtaButton({
  label,
  id,
  microcopy,
  tone = "light"
}: CtaButtonProps) {
  return <div className="mx-auto flex w-full max-w-xl flex-col items-center gap-3" data-id="element-133" data-mp="ckj6ng7zw7l6">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2.5 whitespace-nowrap rounded-2xl bg-cta px-4 py-5 text-center font-display text-xl font-bold uppercase tracking-wide text-navy-950 shadow-cta transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-hover active:translate-y-1 active:shadow-cta-pressed focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-accent sm:text-2xl" data-id="element-134" data-mp="qkaf71fqsvrs">
        <span data-id="element-135" data-mp="159q389nw2n3s">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-136" data-mp="15ahpgtvlj8he" />
      </a>
      {microcopy && <p className={`text-center text-sm ${tone === "dark" ? "text-white/75" : "text-ink-soft"}`} data-id="element-137" data-mp="39zsqtmfskn2u">{microcopy}</p>}
    </div>;
}